import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import Select, { components } from 'react-select';

import Attribute from "views/Accounts/PersonDetails/Attribute";
import "views/Accounts/PersonDetails/personProfileStyle.css";
import { putPersonData, getLabels } from "api/AccountsApi";
import { Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { getDealByIdApi } from "../../../api/SalesApi"
import { Contacts } from "@material-ui/icons";
import { getPersons } from "../../../api/AccountsApi"
import { putDealApi } from "../../../api/SalesApi"
import { updateTaskByIdApi } from "api/SalesApi"
import { getStages, getPiplines } from 'api/SettingsApi'
import './deals.css'
import { getAllUsers } from "api/UsersApi"

const createOption = (label) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
});

const DealDetail = (props) => {
    const [originalData, setOriginalData] = useState(null);
    const [ALLDATA, setALLDATA] = useState([]);
    const [change, setChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [contactsOptions, setContactsOptions] = useState([]);
    const [labelToKeyMap, setLabelToKeyMap] = useState({});
    const [tasks, setTasks] = useState([])
    const [stages, setStages] = useState([]);

    const [notes, setNotes] = useState("");


    const [stage, setStage] = useState(null);
    const [pipeline, setPipeline] = useState(null);

    const [users, setUsers] = useState([]);

    const [owner, setOwner] = useState(null);
    const [assignee, setAssignee] = useState(null);

    const history = useHistory();


    const NoteAttribute = (note) => {
        return <div
            style={{
                display: "flex",
                flexDirection: "row",
                margin: "5px",
                paddingBottom: "20px",
            }}
        >

        </div>
    }
    const [dealId, setDealId] = useState("");

    const customStyles = {
        control: base => ({
            ...base,
            padding: '10px',
            boxShadow: '0 8px 24px rgb(149 157 165 / 20%)'

        })

    }

    useEffect(() => {
        let labelToKey = {}
        let id = history.location.state.dealId;
        setDealId(id);

        getAllUsers(1000, 0).then(users => {
            setUsers(users)
        })



        getPiplines(1000,0)
            .then((data) => {
                let piplines = data;
                getStages(piplines[0].id, 1000, 0)
                    .then((data) => {
                        setStages(data)

                    })
                    .catch((e) => { });
            })
            .catch((e) => { });



        getDealByIdApi(id)
            .then((data) => {
                setOriginalData(data);

                if (data.stage) {
                    setStage(data.stage.id)
                    setPipeline(data.stage.pipeline.name)
                }
                if (data.assignee)
                    setAssignee(data.assignee.id)
                if (data.createdBy)
                    setOwner(data.createdBy.name)

                if (data.tasks)
                    setTasks(data.tasks)

                if (data.text && data.text.label == 'Notes')
                    setNotes(data.text.value)

                // schema
                var allAttrs = Object.keys(data);
                let temp = []

                allAttrs.forEach(attr => {
                    if (attr != 'Notes' && attr != 'text', attr != 'stage' && data[attr] && data[attr].label) {
                        labelToKey[data[attr].label] = attr;
                        if (data[attr].dataType == 'date') {
                            if (data[attr].value) {
                                const d = new Date(data[attr].value);
                                let t = d.toISOString()
                                temp.push({ key: data[attr].label, value: t.split('T')[0], type: data[attr].dataType })

                            }
                            else {
                                temp.push({ key: data[attr].label, value: '', type: data[attr].dataType })

                            }

                        }
                        else if (attr != 'Notes' && attr != 'text') {
                            temp.push({ key: data[attr].label, value: data[attr].value, type: data[attr].dataType })

                        }
                    }
                })
                setLabelToKeyMap(labelToKey)

                setALLDATA(temp)

                // contacts
                let temp2 = []
                data.persons.forEach(obj => {
                    let contact = {
                        label: (obj.firstName + " " + obj.lastName) + " " + `<${obj.email}>`,
                        value: obj.id
                    }

                    temp2.push(contact)

                })
                setContacts(temp2)

            })
            .catch((e) => { });


    }, []);
    const handleInputChange = (inputValue, actionMeta) => {

        if (inputValue) {
            getPersons(1000, 0, inputValue).then(users => {
                users = users.map(u => { return { label: (u.firstName + " " + u.lastName+" "+`<${u.email}>`), value: u.id } })
                setContactsOptions(users)
            })
        }
    };
    const CustomMultiValueContainer = (props) => {

        let em = props.data.label.split('<')[1]
        em = em.split('>')[0]

        return (<div className="CustomMultiValueContainer" onClick={(e) => navigator.clipboard.writeText(em)} title="Copy Email Address"
            style={{
                cursor: 'pointer'
            }}


        >

            <components.MultiValueContainer {...props}>

            </components.MultiValueContainer>
        </div>
        )
    }

    const handleChange = (newValue, actionMeta) => {
        setChange(true);

        console.group("Value Changed");


        console.groupEnd();
        setContacts(newValue);
        // this.setState({ value: newValue });
    };
    const handleCreate = (inputValue) => {
        // this.setState({ isLoading: true });
        setChange(true);
        setIsLoading(true);
        console.group("Option created");

        setTimeout(() => {
            const newOption = createOption(inputValue);

            console.groupEnd();
            setContacts([...contacts, newOption]);
            setIsLoading(false);
        }, 1000);
    };

    const fun = (value, label, _) => {

        let all = [...ALLDATA]
        let t = all.filter(r => r.key == label)
        t = t[0]
        t.value = value
        setALLDATA(all)

    };
    const update = () => {
        let body = {
            assignee: assignee,
            stage: stage,
        };
        ALLDATA.forEach(r => {
            if (r.value)
                body[labelToKeyMap[r.key]] = { value: r.value } //
        })

        body.persons = contacts.map(contact => contact.value)
        let id = history.location.state.dealId;

        body.text = { value: notes }

        putDealApi(id, body).then(() => {
            toast.success("Deal has been updated successfully. ");

        }).catch((error) => {
            toast.error("Something went wrong. Please try again.");
        });;

    };
    const getAttributeSize = () => {
        return ALLDATA.length + tasks.length + 3
    }

    return (
        <>
            <div style={{ display: 'flex', width: 'calc(100% - 250px)' }}>
                <div style={{ flex: 1 }}>

                    <button
                        className="backBtn btn btn-sm "
                        style={{ color: "#114169", marginBottom: "0px" }}
                        onClick={() => props.history.push('/admin/sales/deals')}
                    >

                        <span style={{ paddingTop: "1px", marginLeft: "14px" }}>
                            {`< Back`}
                        </span>
                    </button>

                    <div id="p-container">
                        <br />
                        <br />

                        <h2 className="p-title">Deal Details</h2>

                        <div class="h_line"></div>

                        {ALLDATA ? (
                            <div style={{ paddingLeft: "30px" }}>

                                <div className='pd-main'>

                                    {ALLDATA.map((obj, i) => {
                                        let size = getAttributeSize()
                                        return (
                                            <Attribute
                                                key={i}
                                                label={obj.key}
                                                value={obj.value}
                                                type={obj.type}
                                                dollar={obj.key == 'Amount'}
                                                fun={fun}
                                            // style={i < (size / 4) ? { gridColumnStart: 1, gridColumnEnd: 1, } : { gridColumnStart: 2, gridColumnEnd: 2, }}
                                            // side="left"
                                            ></Attribute>
                                        );
                                    })}

                                    {assignee && <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: "5px",
                                            paddingBottom: "20px",
                                            //   ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                                        }}
                                    >
                                        <div style={{ width: "100%", display: 'flex' }}>
                                            <span style={{ flex: 0.7 }} className="attributeLabel">{'Assignee'}</span>

                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <span
                                                    className="attributeLabel"
                                                    style={{ marginRight: "9px", marginLeft: "3%" }}
                                                >
                                                    :
                                                </span>
                                                <span className="ml-2"></span>
                                                <select value={assignee}

                                                    onChange={(e) => { setAssignee(e.target.value) }}

                                                    className="valueW attributeValue " >
                                                    {users && users.map((stage, i) => {
                                                        return <option value={stage.id} key={i}>{stage.name}</option>
                                                    })}
                                                </select>

                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {owner && <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: "5px",
                                            paddingBottom: "20px",
                                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                                        }}
                                    >
                                        <div style={{ width: "100%", display: 'flex' }}>
                                            <span style={{ flex: 0.7 }} className="attributeLabel">{'Owner'}</span>

                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <span
                                                    className="attributeLabel"
                                                    style={{ marginRight: "9px", marginLeft: "3%" }}
                                                >
                                                    :
                                                </span>
                                                <span className="ml-2"></span>
                                                <div value={owner} className="valueW attributeValue " >
                                                    {/* {users && users.map((stage, i) => {
                                                return <option value={stage.id} key={i}>{stage.name}</option>
                                            })} */}
                                                    {owner}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {stage && <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: "5px",
                                            paddingBottom: "20px",
                                            //  ...{ gridColumnStart: 1, gridColumnEnd: 1, } 

                                        }}
                                    >
                                        <div style={{ width: "100%", display: 'flex' }}>
                                            <span style={{ flex: 0.7 }} className="attributeLabel">{'Stage'}</span>

                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <span
                                                    className="attributeLabel"
                                                    style={{ marginRight: "9px", marginLeft: "3%" }}
                                                >
                                                    :
                                                </span>
                                                <span className="ml-2"></span>
                                                <select value={stage} className="valueW attributeValue "
                                                    onChange={(e) => { setStage(e.target.value) }}
                                                >
                                                    {stages && stages.map((stage, i) => {
                                                        return <option value={stage.id} key={i}>{stage.label}</option>
                                                    })}
                                                </select>

                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {<div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: "5px",
                                            paddingBottom: "20px",
                                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                                        }}
                                    >
                                        <div style={{ width: "100%", display: 'flex' }}>
                                            <span style={{ flex: 0.7 }} className="attributeLabel">{'Notes'}</span>

                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <span
                                                    className="attributeLabel"
                                                    style={{ marginRight: "9px", marginLeft: "3%" }}
                                                >
                                                    :
                                                </span>
                                                <span className="ml-2"></span>
                                                <textarea id='notes' value={notes} style={{
                                                    border: "1px solid rgba(0,0,0,0.2)",
                                                    padding: "7px",
                                                    borderRadius: "5px",
                                                    overflowWrap: 'break-word',
                                                    whiteSpace: 'break-spaces',

                                                    backgroundColor: "rgba(0,150,150,0.02)", height: 'auto', marginLeft: "12px"
                                                }} onChange={(e) => { setNotes(e.target.value) }} className="valueW attributeValue " />


                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {<div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: "5px",
                                            paddingBottom: "20px",
                                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                                        }}
                                    >
                                        <div style={{ width: "100%", display: 'flex' }}>
                                            <span style={{ flex: 0.7 }} className="attributeLabel">{'Pipeline'}</span>

                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <span
                                                    className="attributeLabel"
                                                    style={{ marginRight: "9px", marginLeft: "3%" }}
                                                >
                                                    :
                                                </span>
                                                <span className="ml-2"></span>

                                                {pipeline}

                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {/* {tasks.map(t => {
                                return TaskAttribute(t);
                             })} */}


                                </div>
                                <h6 className="p-groupTitle mt-4">Contacts</h6>
                                <div style={{ width: "70%", marginLeft: "4.5%" }}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={() => undefined}
                                        // onChange={handleChangeTags}
                                        onInputChange={handleInputChange}
                                        value={contacts}
                                        styles={customStyles}
                                        placeholder={"Add.."}
                                        onChange={handleChange}
                                        onCreateOption={handleCreate}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                        options={contactsOptions}
                                        components={{ MultiValueContainer: CustomMultiValueContainer }}

                                    />
                                </div>


                            </div>
                        ) : (
                            ""
                        )}

                        <div style={{margin:"40px"}}>
                            <input
                                type="submit"
                                name="Save"
                                style={{ cursor: "pointer" }}
                                className="lg_btn secondary mb-2"
                                id="profileSave"
                                value="SAVE"
                                onClick={() => update()}
                            />

                            <input
                                type="submit"
                                name="Save"
                                style={{ cursor: "pointer" }}
                                className="lg_btn secondary mb-2"
                                id="profileCancel"
                                value="Cancel"
                                onClick={() =>
                                    props.history.push(`/admin/sales/deals`)
                                }
                            />
                        </div>

                    </div>
                </div>

            </div>
            <div style={{
                width: '250px',
                borderLeft: '1px solid',
                padding: '12px 12px',
                height: '100vh',
                position: 'fixed',
                right: '0',
                top: '0'
            }}>
                <h6 className="p-groupTitle mt-4">Tasks</h6>
                <div style={{ width: "100%", marginLeft: "5px" }}>
                    <div className="mb-3 mt-3" style={{
                        display: "flex",
                        fontSize: '14px',
                        fontWeight: 900
                    }}>
                        <div style={{ width: "100px" }} >Status</div>
                        <div>Name</div>
                    </div>

                    {
                        tasks.map(t => {
                            return <div style={{ display: "flex", padding: '7px 0px' }}>
                                <div className='pl-2' style={{ width: "100px" }}>
                                    {t.status == 'active' && <i title="active"
                                        className="far fa-check-circle"
                                        style={{ color: "grey", fontSize: "20px", cursor: 'pointer' }}
                                        onClick={(e) => {

                                            updateTaskByIdApi(t.id, { status: 'completed' })
                                            let data = [...tasks]
                                            data.find(r => r.id == t.id).status = 'completed'
                                            setTasks(data)



                                        }}
                                    ></i>
                                    }
                                    {t.status == 'completed' && <i title="completed"
                                        className="far fa-check-circle"
                                        style={{ color: "green", fontSize: "20px", cursor: 'pointer' }}
                                        onClick={(e) => {
                                            updateTaskByIdApi(t.id, { status: 'active' })
                                            let data = [...tasks]
                                            data.find(r => r.id == t.id).status = 'active'
                                            setTasks(data)


                                        }}
                                    ></i>
                                    }

                                    {t.status == 'overdue' && <i title="overdue"
                                        className="far fa-check-circle"
                                        style={{ color: "rgba(150,0,0,0.8)", fontSize: "20px", cursor: 'pointer' }}
                                        onClick={(e) => {
                                            updateTaskByIdApi(t.id, { status: 'completed' })
                                            let data = [...tasks]
                                            data.find(r => r.id == t.id).status = 'completed'
                                            setTasks(data)


                                        }}
                                    ></i>
                                    }
                                </div>
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        history.push("/admin/sales/tasks?id=" + t.id);
                                    }}
                                    //  className={`nav-link ${currentStatus}`}
                                    style={{
                                        color: '#007bff',

                                    }}
                                    title="view details"
                                    href={'#'}

                                > {t.title}</a>

                            </div>
                        })
                    }


                </div>
            </div>
        </>
    );
};

export default DealDetail;
